import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { valueActionCreator } from "../action_creators";
// eslint-disable-next-line @typescript-eslint/no-unused-vars

export var APPLICATION_SET_ADVISOR_ACTION = 'APPLICATION_SET_ADVISOR_ACTION';
export var APPLICATION_SET_APPLICATION_ACTION = 'APPLICATION_SET_APPLICATION_ACTION';
export var APPLICATION_SET_DATES_ACTION = 'APPLICATION_SET_DATES_ACTION';
export var APPLICATION_SET_ID_ACTION = 'APPLICATION_SET_ID_ACTION';
export var APPLICATION_SET_OTHER_APPLICATIONS_ACTION = 'APPLICATION_SET_OTHER_APPLICATIONS_ACTION';
export var APPLICATION_SET_OTHER_APPLICATIONS_LOADED_ACTION = 'APPLICATION_SET_OTHER_APPLICATIONS_LOADED_ACTION';
export var APPLICATION_SET_OTHER_APPLICATIONS_LOADING_ACTION = 'APPLICATION_SET_OTHER_APPLICATIONS_LOADING_ACTION';
export var APPLICATION_SET_PERMISSIONS_ACTION = 'APPLICATION_SET_PERMISSIONS_ACTION';
export var APPLICATION_SET_PREVIEW_REQUIREMENT_ID_ACTION = 'APPLICATION_SET_PREVIEW_REQUIREMENT_ID_ACTION';
export var APPLICATION_SET_PREVIEW_REQUIREMENT_FILE_ID_ACTION = 'APPLICATION_SET_PREVIEW_REQUIREMENT_FILE_ID_ACTION';
export var APPLICATION_SET_PROGRAM_ACTION = 'APPLICATION_SET_PROGRAM_ACTION';
export var APPLICATION_SET_PROGRAM_ESL_ACTION = 'APPLICATION_SET_PROGRAM_ESL_ACTION';
export var APPLICATION_SET_REQUIREMENTS_LOADING_ACTION = 'APPLICATION_SET_REQUIREMENTS_LOADING_ACTION';
export var APPLICATION_SET_ROWLOADING_ACTION = 'APPLICATION_SET_ROWLOADING_ACTION';
export var APPLICATION_SET_SCHOOL_ACTION = 'APPLICATION_SET_SCHOOL_ACTION';
export var APPLICATION_SET_STATUS_ACTION = 'APPLICATION_SET_STATUS_ACTION';
export var APPLICATION_SET_CANCEL_STATUS_ACTION = 'APPLICATION_SET_CANCEL_STATUS_ACTION';
export var APPLICATION_SET_CANCELLATION_REASON_ACTION = 'APPLICATION_SET_CANCELLATION_REASON_ACTION';
export var APPLICATION_SET_CANCELLATION_ADDITIONAL_NOTE_ACTION = 'APPLICATION_SET_CANCELLATION_ADDITIONAL_NOTE_ACTION';
export var APPLICATION_SET_META_ACTION = 'APPLICATION_SET_META_ACTION';
export var APPLICATION_SET_STUDENT_PROFILE_ACTION = 'APPLICATION_SET_STUDENT_PROFILE_ACTION';
export var APPLICATION_SET_TAB_ACTION = 'APPLICATION_SET_TAB_ACTION';
export var APPLICATION_SIDEBAR_TOGGLE_EXPANDED_ACTION = 'APPLICATION_SIDEBAR_TOGGLE_EXPANDED_ACTION';
export var APPLICATION_SET_CREATE_REQUIREMENT_ACTION = 'APPLICATION_SET_CREATE_REQUIREMENT_ACTION';
export var SHOW_REQ_COUNT_ACTION = 'SHOW_REQ_COUNT_ACTION';
export var HIDE_REQ_COUNT_ACTION = 'HIDE_REQ_COUNT_ACTION';
export var SET_APP_REQ_COUNT = 'SET_APP_REQ_COUNT';
export var SET_ACTIONS_COUNT = 'SET_ACTIONS_COUNT';
export var APPLICATION_SET_EDIT_REQUIREMENT_ACTION = 'APPLICATION_SET_EDIT_REQUIREMENT_ACTION';
export var APPLICATION_CLEAR_EDIT_REQUIREMENT_ACTION = 'APPLICATION_CLEAR_EDIT_REQUIREMENT_ACTION';
export var IS_INITIAL_ACTUAL_START_DATES_ACTION = 'IS_INITIAL_ACTUAL_START_DATES_ACTION';
export var SAVED_PROGRAM_INTAKE_START_DATE_ACTION = 'SAVED_PROGRAM_INTAKE_START_DATE_ACTION';
export var NOTES_ADD_FILE_NEW_NOTE_ACTION = 'NOTES_ADD_FILE_NEW_NOTE_ACTION';
export var NOTES_ADD_FILE_NEW_PRIVATE_NOTE_ACTION = 'NOTES_ADD_FILE_NEW_PRIVATE_NOTE_ACTION';
export var NOTES_CLEAR_FILES_NEW_NOTE_ACTION = 'NOTES_CLEAR_FILES_NEW_NOTE_ACTION';
export var NOTES_CLEAR_FILES_NEW_PRIVATE_NOTE_ACTION = 'NOTES_CLEAR_FILES_NEW_PRIVATE_NOTE_ACTION';
export var NOTES_DELETE_ACTION = 'NOTES_DELETE_ACTION';
export var NOTES_INSERT_ACTION = 'NOTES_INSERT_ACTION';
export var NOTES_RECEIVED_ACTION = 'NOTES_RECEIVED_ACTION';
export var NOTES_REMOVE_FILE_NEW_NOTE_ACTION = 'NOTES_REMOVE_FILE_NEW_NOTE_ACTION';
export var NOTES_REMOVE_FILE_NEW_PRIVATE_NOTE_ACTION = 'NOTES_REMOVE_FILE_NEW_PRIVATE_NOTE_ACTION';
export var NOTES_SET_ADDING_ACTION = 'NOTES_SET_ADDING_ACTION';
export var NOTES_SET_ADDING_PRIVATE_ACTION = 'NOTES_SET_ADDING_PRIVATE_ACTION';
export var NOTES_SET_LOADING_ACTION = 'NOTES_SET_LOADING_ACTION';
export var NOTES_SET_NEW_NOTE_LOADING_ACTION = 'NOTES_SET_NEW_NOTE_LOADING_ACTION';
export var NOTES_SET_NEW_PRIVATE_NOTE_LOADING_ACTION = 'NOTES_SET_NEW_PRIVATE_NOTE_LOADING_ACTION';
export var NOTES_SET_WITH_ALERT_ONLY_ACTION = 'NOTES_SET_WITH_ALERT_ONLY_ACTION';
export var NOTES_UPDATE_NEW_NOTE_ACTION = 'NOTES_UPDATE_NEW_NOTE_ACTION';
export var NOTES_UPDATE_NEW_PRIVATE_NOTE_ACTION = 'NOTES_UPDATE_NEW_PRIVATE_NOTE_ACTION';
export var applicationSetAdvisorAction = valueActionCreator(APPLICATION_SET_ADVISOR_ACTION);
export var applicationSetProgramAction = valueActionCreator(APPLICATION_SET_PROGRAM_ACTION);
export var applicationSetProgramEslAction = valueActionCreator(APPLICATION_SET_PROGRAM_ESL_ACTION);
export var applicationSetSchoolAction = valueActionCreator(APPLICATION_SET_SCHOOL_ACTION);
export var notesAddFileNewNoteAction = valueActionCreator(NOTES_ADD_FILE_NEW_NOTE_ACTION);
export var notesAddFileNewPrivateNoteAction = valueActionCreator(NOTES_ADD_FILE_NEW_PRIVATE_NOTE_ACTION);
export var notesClearFilesNewNoteAction = valueActionCreator(NOTES_CLEAR_FILES_NEW_NOTE_ACTION);
export var notesClearFilesNewPrivateNoteAction = valueActionCreator(NOTES_CLEAR_FILES_NEW_PRIVATE_NOTE_ACTION);
export var notesDeleteAction = valueActionCreator(NOTES_DELETE_ACTION);
export var notesInsertAction = valueActionCreator(NOTES_INSERT_ACTION);
export var notesRemoveFileNewNoteAction = valueActionCreator(NOTES_REMOVE_FILE_NEW_NOTE_ACTION);
export var notesRemoveFileNewPrivateNoteAction = valueActionCreator(NOTES_REMOVE_FILE_NEW_PRIVATE_NOTE_ACTION);
export var notesSetNewNoteLoadingAction = valueActionCreator(NOTES_SET_NEW_NOTE_LOADING_ACTION);
export var notesSetNewPrivateNoteLoadingAction = valueActionCreator(NOTES_SET_NEW_PRIVATE_NOTE_LOADING_ACTION);
export var notesSetWithAlertOnlyAction = valueActionCreator(NOTES_SET_WITH_ALERT_ONLY_ACTION);
export var notesUpdateNewNoteAction = valueActionCreator(NOTES_UPDATE_NEW_NOTE_ACTION);
export var notesSetAddingAction = function notesSetAddingAction(adding, clear) {
  var visibility = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'public';
  return {
    type: NOTES_SET_ADDING_ACTION,
    adding: adding,
    clear: clear,
    visibility: visibility
  };
};
export var notesUpdateNewPrivateNoteAction = function notesUpdateNewPrivateNoteAction(value) {
  return {
    type: NOTES_UPDATE_NEW_PRIVATE_NOTE_ACTION,
    value: _objectSpread(_objectSpread({}, value), {}, {
      visibility: 'private'
    })
  };
};
export var notesSetAddingPrivateAction = function notesSetAddingPrivateAction(adding, clear) {
  var visibility = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'private';
  return {
    type: NOTES_SET_ADDING_PRIVATE_ACTION,
    adding: adding,
    clear: clear,
    visibility: visibility
  };
};